<template><div></div></template>

<script>
export default {
  name: "LiveVideoWidget"
}
</script>

<style scoped>

</style>
